export const STORAGE_KEY_DENSE = "users_table_dense";
export const STORAGE_KEY_RPP = "users_table_rows_per_page";

export const headCells = [
  { id: "select", label: "", numeric: false, disablePadding: true, sortable: false },
  { id: "avatar", label: "Avatar", numeric: false, disablePadding: false, sortable: false },
  { id: "fullName", label: "Nombre Apellido", numeric: false, disablePadding: false, sortable: true },
  { id: "email", label: "Email", numeric: false, disablePadding: false, sortable: true },
  { id: "alias", label: "Alias", numeric: false, disablePadding: false, sortable: false },
  { id: "instagram", label: "Instagram", numeric: false, disablePadding: false, sortable: true },
  { id: "phone", label: "Teléfono", numeric: false, disablePadding: false, sortable: true },
  { id: "dni", label: "DNI", numeric: true, disablePadding: false, sortable: true },
  { id: "user_location", label: "Dirección", numeric: false, disablePadding: false, sortable: true },
  { id: "membership", label: "Membresía", numeric: false, disablePadding: false, sortable: false },
  { id: "enabled", label: "Habilitado", numeric: false, disablePadding: false, sortable: false },

];
